import { useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { getDeployedRegion } from 'utils/env';
import { syncWhatsAppAndFetchEspAccountMutation } from 'api/mutations/sendingPlatforms';
import { useWhatsAppAccountsContext } from 'modules/sendingPlatforms/contexts';

export const ContinueWithFacebookButton = () => {
  const dispatch = useDispatch();
  const { isLoadingWhatsAppAccounts, whatsAppAccounts } = useWhatsAppAccountsContext();
  const { appId, configId, euSolutionId, usSolutionId } =
    whatsAppAccounts?.getWhatsAppMetaConfigValues || {};

  const [syncWhatsAppFetchEspAccountMutation] = useMutation(
    syncWhatsAppAndFetchEspAccountMutation,
    {
      /* istanbul ignore next */
      onCompleted({ syncWhatsAppAndFetchEspAccount }) {
        /* eslint-disable */
        console.log(syncWhatsAppAndFetchEspAccount);
        window.location.reload();
      },
    },
  );

  const solutionId = getDeployedRegion() === 'eu' ? euSolutionId : usSolutionId;

  useEffect(() => {
    /* istanbul ignore next */
    if (!isLoadingWhatsAppAccounts && whatsAppAccounts?.getWhatsAppMetaConfigValues) {
      window.fbAsyncInit = () => {
        // JavaScript SDK configuration and setup
        window?.FB?.init({
          appId,
          // Facebook App ID
          cookie: true, // enable cookies
          xfbml: true, // parse social plugins on this page
          version: 'v20.0', // Graph API version
        });
      };
      // eslint-disable-next-line prefer-const
      const fjs = document.getElementsByTagName('script')[0];
      if (document.getElementById('facebook-jssdk')) return;
      const js = document.createElement('script');
      js.id = 'facebook-jssdk';
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode?.insertBefore(js, fjs);
      return () => {
        // clean up
        document.getElementById('facebook-jssdk')?.remove();
        window.fbAsyncInit = undefined;
      };
    }
  }, [window, isLoadingWhatsAppAccounts, whatsAppAccounts]);

  useEffect(() => {
    /* istanbul ignore next */
    if (window) {
      /* eslint-disable */
      const sessionInfoListener = (event: any) => {
        if (event.origin == null) {
          return;
        }

        // Make sure the data is coming from facebook.com
        if (!event.origin.endsWith('facebook.com')) {
          return;
        }

        try {
          const data = JSON.parse(event.data);
          if (data.type === 'WA_EMBEDDED_SIGNUP') {
            // if user finishes the Embedded Signup flow
            if (data.event === 'FINISH') {
              const { waba_id } = data.data;
              dispatch(addPositiveToast('Success! Setting up your WhatsApp Business Account...'));
              syncWhatsAppFetchEspAccountMutation({
                variables: {
                  businessAccountId: waba_id,
                },
              });
            }
            // if user reports an error during the Embedded Signup flow
            else if (data.event === 'ERROR') {
              const { error_message } = data.data;
              dispatch(
                addNegativeToastWithErrorId(
                  'Something went wrong, please refresh and try again. If the problem persists, contact your CSM.',
                  'embeddedSignUp',
                  error_message,
                ),
              );
            }
            // if user cancels the Embedded Signup flow
            else {
              const { current_step } = data.data;
              console.warn('Cancel at ', current_step);
            }
          }
        } catch {
          // Don’t parse info that’s not a JSON
          console.log('Non JSON Response', event.data);
        }
      };

      window.addEventListener('message', sessionInfoListener);
    }
  }, [window]);

  /* istanbul ignore next */
  const launchWhatsAppSignup = () => {
    // Launch Facebook login
    window.FB?.login(
      // eslint-disable-next-line func-names
      function (response: any) {
        if (response.authResponse) {
          const { code } = response.authResponse;
          // The returned code must be transmitted to your backend,
          // which will perform a server-to-server call from there to our servers for an access token
        } else {
          console.log('User cancelled login or did not fully authorize.');
        }
      },
      {
        config_id: configId, // configuration ID goes here
        response_type: 'code', // must be set to 'code' for System User access token
        override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
        extras: {
          setup: { solutionID: solutionId },
          feature: 'whatsapp_embedded_signup',
          sessionInfoVersion: 3, //  Receive Session Logging Info
        },
      },
    );
  };
  return (
    <button
      onClick={launchWhatsAppSignup}
      id="whatsAppSignUp"
      style={{
        backgroundColor: '#1877f2',
        border: 0,
        borderRadius: '4px',
        color: '#fff',
        cursor: 'pointer',
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontSize: '16px',
        fontWeight: 'bold',
        height: '40px',
        padding: '0 24px',
      }}
    >
      Continue with Facebook
    </button>
  );
};
